<template>
  <div class="left">

    <el-aside width="90" style="background-color: #304156" :collapse="this.$store.state.boo">
    <el-menu
     class="el-menu-vertical-demo"
     @open="handleOpen"
     @close="handleClose"
     :default-openeds="['/system', '/party','/ePower','/talent','/hetong','/eLife','/crmlist','/afterorder']"
     :collapse-transition="true"
     :default-active="$route.path"
      router
      background-color="#304156"
      text-color="#eee"
      :collapse="$store.state.boo"
         >
      <!-- <el-menu-item>
        <template>
          <i class="el-icon-location"></i>
          <span slot="title">首页</span>
        </template>
      </el-menu-item> -->
      <h3>
        <i></i>
        <span :class="{'hide':$store.state.boo}">采销中心</span>

      </h3>
      <el-menu-item index="/index/dashboard" class="submenu-title-noDropdown" v-if="userType !== 'caigou'">
        <i class="el-icon-menu"></i>
        <span slot="title">
          工作台
        </span>
      </el-menu-item>
      <el-menu-item index="/index/Workcg" class="submenu-title-noDropdown" v-if="userType === 'caigou'">
        <i class="el-icon-menu"></i>
        <span slot="title">
          工作台
        </span>
      </el-menu-item>
        <el-menu-item index="/index/statistics" class="submenu-title-noDropdown" v-if="userType !== 'caigou'">
            <i class="el-icon-s-order"></i>
            <span slot="title">数据统计</span>
        </el-menu-item>
        <el-submenu index="/system" v-if="userType !== 'caigou'">
          <template slot="title">
            <i class="el-icon-setting"></i>
            <span slot="title">商家管理</span>
          </template>
          <el-menu-item index="/system/user" v-if="userType === 'wholesaler'">审核管理</el-menu-item>
           <el-menu-item index="/system/userjx" v-if="userType === 'wholesaler'">经销管理</el-menu-item>
          <!-- <el-menu-item index="/system/role" v-if="userType === 'wholesaler'">订单列表</el-menu-item> -->
          <el-menu-item index="/system/orderjx" v-if="userType === 'retailer'">订单列表</el-menu-item>
          <el-menu-item index="/system/logistics" v-if="userType === 'retailer'">物流列表</el-menu-item>
          <!-- <el-menu-item index="/system/menu">证件审核</el-menu-item> -->
          <!-- <el-menu-item index="/system/dept">注册店铺</el-menu-item> -->
          <!-- <el-menu-item index="/system/notice">轮播图管理</el-menu-item> -->
        </el-submenu>
        <el-submenu index="/party" v-if="userType !== 'caigou'" >
          <template slot="title">
            <i class="el-icon-s-shop"></i>
            <span>商品管理</span>
          </template>
           <el-menu-item index="/party/member" v-if="userType === 'wholesaler'">商品列表</el-menu-item>
            <el-menu-item index="/party/memberjx" v-if="userType === 'retailer'">代理商品</el-menu-item>
           <el-menu-item index="/party/stock" v-if="userType === 'wholesaler'">商品入库</el-menu-item>
           <el-menu-item index="/party/shmanage" v-if="userType === 'wholesaler'">产品管理</el-menu-item>
        </el-submenu>

        <el-submenu index="/ePower" v-if="userType !== 'retailer'">
          <template slot="title">
            <i class="el-icon-s-claim"></i>
            <span>订单管理</span>
          </template>
          <el-menu-item index="/ePower/lifeInfo" v-if="userType === 'wholesaler'">订单列表</el-menu-item>
          <el-menu-item index="/ePower/education" v-if="userType === 'wholesaler'">派单列表</el-menu-item>
           <el-menu-item index="/ePower/partyBuilding" v-if="userType === 'wholesaler'">物流列表</el-menu-item>
          <el-menu-item index="/ePower/connection" v-if="userType === 'caigou'">订单列表</el-menu-item>
          <el-menu-item index="/ePower/ordersh" v-if="userType === 'caigou'">售后订单</el-menu-item>
           <el-menu-item index="/ePower/orderdz" v-if="userType === 'caigou'">收货地址</el-menu-item>
        </el-submenu>
         <el-submenu index="/afterorder" v-if="userType === 'wholesaler'">
          <template slot="title">
            <i class="el-icon-location"></i>
            <span>售后管理</span>
          </template>
          <el-menu-item index="/afterorder/orderlist">售后列表</el-menu-item>
          <!-- <el-menu-item index="/integral/supermarket">积分超市</el-menu-item> -->
        </el-submenu>
        <el-submenu index="/talent" v-if="userType !== 'caigou'">
          <template slot="title">
            <i class="el-icon-s-home"></i>
            <span>库存管理</span>
          </template>
          <el-menu-item index="/talent/talentWork" v-if="userType === 'wholesaler'">库存查询</el-menu-item>
          <el-menu-item index="/talent/talentPool" v-if="userType === 'wholesaler'">库存变更记录</el-menu-item>
          <el-menu-item index="/talent/antStar" v-if="userType === 'retailer'">要货记录</el-menu-item>
          <el-menu-item index="/talent/training" v-if="userType === 'retailer'">要货申请</el-menu-item>
          <el-menu-item index="/talent/talentCenter" v-if="userType === 'wholesaler'">经销商要货</el-menu-item>
        </el-submenu>
        <el-submenu index="/hetong" v-if="userType !== 'retailer'">
          <template slot="title">
            <i class="el-icon-s-management"></i>
            <span>合同管理</span>
          </template>
          <el-menu-item index="/hetong/hetongList" v-if="userType === 'wholesaler'">合同列表</el-menu-item>
          <el-menu-item index="/hetong/hetongcgList" v-if="userType === 'caigou'">合同列表</el-menu-item>
          <el-menu-item index="/hetong/whhetong" v-if="userType === 'wholesaler'">合同维护</el-menu-item>
          <el-menu-item index="/hetong/whhetongList" v-if="userType === 'wholesaler'">维护列表</el-menu-item>
        </el-submenu>

        <!-- <el-submenu index="/eStudy">
          <template slot="title">
            <i class="el-icon-location"></i>
            <span>e学习</span>
          </template>
          <el-menu-item index="/eStudy/video">视频学习</el-menu-item>
          <el-menu-item index="/eStudy/theory">理论学习</el-menu-item>
        </el-submenu> -->
        <!-- <el-submenu index="/activities">
          <template slot="title">
            <i class="el-icon-location"></i>
            <span>党群活动</span>
          </template>
          <el-menu-item index="/activities/law">乡镇（街道）</el-menu-item>
          <el-menu-item index="/activities/close">机关活动</el-menu-item>
          <el-menu-item index="/activities/popularity">两新组织活动</el-menu-item>
          <el-menu-item index="/activities/publication">发布活动</el-menu-item>
          <el-menu-item index="/activities/resident">共筑共建</el-menu-item>
          <el-menu-item index="/activities/front">阵地预约审核</el-menu-item>
        </el-submenu> -->
        <!-- <el-submenu index="/babyWish">
          <template slot="title">
            <i class="el-icon-location"></i>
            <span>微心愿</span>
          </template>
          <el-menu-item index="/babyWish/checkWish">心愿审核</el-menu-item>
        </el-submenu> -->
         <el-submenu index="/crmlist" v-if="userType === 'wholesaler'">
          <template slot="title">
            <i class="el-icon-user"></i>
            <span>会员</span>
          </template>
           <el-menu-item index="/crmlist/Crmlist" >会员列表</el-menu-item>
        </el-submenu>
       <el-submenu index="/eLife">
          <template slot="title">
            <i class="el-icon-user"></i>
            <span>我的</span>
          </template>
          <el-menu-item index="/eLife/policy" v-if="userType !== 'caigou'">基本信息</el-menu-item>
          <el-menu-item index="/eLife/caiadmin" v-if="userType === 'caigou'">个人信息</el-menu-item>
          <el-menu-item index="/eLife/Certification" v-if="userType === 'caigou'">公司认证</el-menu-item>
          <el-menu-item index="/eLife/Certlist" v-if="userType === 'caigou'">公司列表</el-menu-item>
          <el-menu-item index="/eLife/Changepass">修改密码</el-menu-item>
        </el-submenu>
      </el-menu>
      </el-aside>

  </div>
</template>

<script>
export default {
  data () {
    return {
      isCollapse: true,
      userType: ''
    }
  },
  watch: {
    // $route(to){
    //   const {name}=to;
    //   this.$router.push({
    //     name
    //   })
    // }
  },
  mounted () {
    this.userType = localStorage.getItem('user_type')
  },
  methods: {
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    }
  }
}
</script>

<style lang="scss">
h3 {
  height: 56px;
  line-height: 56px;
  color: white;
  text-align: center;
  align-items: center;
}
h3 > i {
  display: inline-block;
  width: 28px;
  height: 28px;
  background: url(http://120.46.68.67:8586/static/img/logo.381d6a3e.png)
    no-repeat 0 0/100%;
  vertical-align: middle;
}

* {
  margin: 0;
  padding: 0;
}
h3 > .hide {
  /* display:inline-block;
  width:0;
  overflow: hidden; */
  display: none;
  width: 0;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  height: 100vh;
  /* border:none; */
}
.el-aside::-webkit-scrollbar {
  display: none;
}
.el-menu {
  border: none;
}
.el-menu--collapse {
  height: 100vh;
  border: none;
}
.icon {
  font-size: 40px;
}
.el-submenu__title>img{
  width: 20px;
  margin: 0 10px;
}
.el-menu-item {
  background-color: #1f2d3d !important;
}
.submenu-title-noDropdown{
  background-color: rgb(48, 65, 86) !important;
}
</style>
